import { render } from "./VerifyBySms.vue?vue&type=template&id=31d60987&scoped=true"
import script from "./VerifyBySms.vue?vue&type=script&lang=js"
export * from "./VerifyBySms.vue?vue&type=script&lang=js"

import "./VerifyBySms.vue?vue&type=style&index=0&id=31d60987&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d60987"]])

export default __exports__